import React from "react";
import { DownArrowIcon } from "../../../../../assets/icons/DownArrowIcon";
import { INFO_BOXES } from "../partnered-data";
import "./info-boxes.m.css";

export const InfoBoxes = () => {
  return (
    <section styleName="three-box-section">
      <div styleName="centered">
        <div styleName="content-container">
          <div styleName="three-box-row">
            {INFO_BOXES.map(({ title, description, href }) => (
              <div key={title} styleName="info-box">
                <p styleName="info-box-title">{title}</p>
                <p styleName="info-box-description">{description}</p>
                <a href={href} styleName="info-box-link">
                  Learn more
                  <DownArrowIcon />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
